<template>
    <div class="text-center">
        <el-button type="primary" class="regist_btn" @click="submitForm()">
            저장
        </el-button>
    </div>
</template>

<script>
export default {
    name: "ItemCreateSaveLayout",
    mixins: [],
    components: {
    },
    props: {
        writeItem: {default: () => {}, type: Function},
    },
    data() {
        return {}
    },
    created() {},
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        submitForm() {
            this.writeItem();
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
